import {observer} from "mobx-react";
import {CyClass} from "../../../../../../common/cy-classes";
import {useServices} from "../../../../../react-hooks/use-services.hook";
import {IModalDialogHandler} from "../../../../../services/dialog/dialog.service.interface";
import {DialogCloseButtonBox} from "../../../../modal-dialog/boxes/close-button/dialog-close-button.box";
import {OptInDialogHeaderBox} from "./boxes/opt-in-dialog-header.box";

interface OptInDialogHeaderProps {
    dialogHandler: IModalDialogHandler;
}
export const OptInDialogHeaderComponent: React.FC<OptInDialogHeaderProps> = observer((props) => {
    const services = useServices();
    let JackpotIconIcon = services.theme.currentTheme.icons.blackjackIcon;
    return (
        <OptInDialogHeaderBox>
            <div style={{display: "flex", justifyContent: "end"}}>
                <DialogCloseButtonBox className={CyClass('cy-modal-dialog-x-close-button')} onClick={() => props.dialogHandler.close()} />
            </div>
            <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                <JackpotIconIcon size={6.2} style={{marginRight: "10px", color: services.theme.currentTheme.colors.brandPrimary}} />
                {services.translation.translate('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nisl dui, fringilla euismod nibh id, lobortis sollicitudin mi.')}
            </div>
        </OptInDialogHeaderBox>
    )
})